/* istanbul ignore next */
const styles = {
  amountCell: {
    '&.override-for-glu-grid': {
      '& button': {
        padding: 0
      }
    }
  }
};

export default styles;
